<template>
  <div>
    <div v-if="loading || !formLoaded">
      <span class="spinner"></span>
    </div>
    <div v-if="!loading && formLoaded">
      <b-form
        @submit.stop.prevent="onSubmit"
        :class="{
          'p-3 box-shadow2 rounded': !isDarkMode,
          'dark-div p-3 box-shadow2 rounded': isDarkMode
        }"
      >
        <b-row>
          <b-col>
            <h4 class="page-title"> Details</h4>
            <b-row>
              <b-col>
                <b-form-group id="group-mobile" label-for="input-mobile">
                  <template v-slot:label>
                    Customer Mobile No.
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                    id="input-mobile"
                    v-model="form.mobile"
                    :formatter="limit"
                    type="number"
                    placeholder="Enter Mobile Number"
                    :state="$v.form.mobile.$dirty ? !$v.form.mobile.$error : null"
                  ></b-form-input>

                  <b-form-text id="input-mobile-help">Mobile Number must be a valid 10 digit long number.</b-form-text>

                  <b-form-invalid-feedback id="input-email-invalid"
                    >Please enter valid mobile number.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col sm="12" lg="6">
                <b-form-group id="group-name" label-for="input-name">
                  <template v-slot:label>
                    Customer Name
                    <span class="text-danger">*</span>
                  </template>

                  <b-form-input
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                    id="input-name"
                    type="text"
                    v-model="form.name"
                    :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
                    placeholder="Enter Name"
                  ></b-form-input>

                  <b-form-invalid-feedback id="input-name-invalid">Please enter name.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="6">
                <b-form-group id="group-name" label-for="input-name">
                  <template v-slot:label>
                    Customer Address
                    <span class="text-danger">*</span>
                  </template>

                  <b-form-textarea
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                    id="input-name"
                    type="text"
                    v-model="form.address"
                    :state="$v.form.address.$dirty ? !$v.form.address.$error : null"
                    placeholder="Enter Address"
                  ></b-form-textarea>

                  <b-form-invalid-feedback id="input-name-invalid">Please enter address.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="group-products" label-for="input-products">
                  <template v-slot:label> Select Pincode </template>
                  <multiselect
                    :class="{
                      'box-shadow3': !isDarkMode,
                      darkMode: isDarkMode
                    }"
                    v-model="form.pinCode"
                    ref="multiselect"
                    placeholder="Select Pincode"
                    :options="pinCodeOptions"
                  ></multiselect>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-row>
              <b-col sm="12" lg="6">
                <b-form-group id="group-gender" label-for="input-gender">
                  <template v-slot:label> Gender </template>
                  <multiselect
                    :class="{
                      'box-shadow3': !isDarkMode,
                      darkMode: isDarkMode
                    }"
                    id="input-gender"
                    :options="['Male', 'Female', 'Other']"
                    v-model="form.gender"
                    placeholder="Select Company"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="group-age" label-for="input-age">
                  <template v-slot:label> Age </template>
                  <multiselect
                    :class="{
                      'box-shadow3': !isDarkMode,
                      darkMode: isDarkMode
                    }"
                    v-model="form.age"
                    ref="multiselect"
                    placeholder="Select Age"
                    :options="['0-10', '10-20', '20-30', '30-40', '40-50', '50-60', '61 and Above']"
                  ></multiselect> </b-form-group
              ></b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group id="group-products" label-for="input-products">
                  <template v-slot:label> Offer Communication Mode <span class="text-danger">*</span> </template>
                  <multiselect
                    :class="{
                      'box-shadow3': !isDarkMode,
                      darkMode: isDarkMode
                    }"
                    v-model="form.communicationMode"
                    ref="multiselect"
                    placeholder="Select Mode"
                    :options="['WHATSAPP', 'SMS', 'TELECALLING']"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group v-if="form.role === 99">
                  <template v-slot:label>
                    Store Id
                    <span class="text-danger">*</span>
                  </template>
                  <model-select class="box-shadow2" :options="options" v-model="storeid" placeholder="Select Store Id">
                  </model-select>
                  <b-form-text id="input-role-help"
                    >Please select a store id you want to associate with this user.</b-form-text
                  >
                </b-form-group>

                <b-form-group v-else id="group-products" label-for="input-products">
                  <template v-slot:label> Favourite Store </template>
                  <multiselect
                    v-model="form.store"
                    ref="multiselect"
                    placeholder="Select Store"
                    :options="options"
                    :class="{
                      'box-shadow3': !isDarkMode,
                      darkMode: isDarkMode
                    }"
                  ></multiselect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="6">
                <b-form-group id="group-name" label-for="input-name">
                  <template v-slot:label>
                    Employee Id
                    <span class="text-danger">*</span>
                  </template>

                  <b-form-input
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                    id="input-name"
                    type="text"
                    v-model="form.department"
                    :state="$v.form.department.$dirty ? !$v.form.department.$error : null"
                    placeholder="Enter Employee Id"
                  ></b-form-input>

                  <b-form-invalid-feedback id="input-name-invalid">Please enter department.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="12" lg="6">
                <b-form-group id="group-name" label-for="input-name">
                  <template v-slot:label>
                    Created By Name
                    <span class="text-danger">*</span>
                  </template>

                  <b-form-input
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                    id="input-name"
                    type="text"
                    v-model="form.createdBy"
                    :state="$v.form.createdBy.$dirty ? !$v.form.createdBy.$error : null"
                    placeholder="Enter Name"
                  ></b-form-input>

                  <b-form-invalid-feedback id="input-name-invalid">Please enter name.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <template v-if="errorMessages">
              <b-row class="mb-2">
                <b-col class="text-danger message-col">{{ errorMessages }}</b-col>
              </b-row>
            </template>

            <template v-if="storeIdError">
              <b-row class="mb-2">
                <b-col class="text-danger message-col">{{ storeIdError }}</b-col>
              </b-row>
            </template>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-button
              class="box-shadow2"
              type="submit"
              size="sm"
              :variant="isDarkMode ? 'outline-success' : 'success'"
              :disabled="loading"
            >
              <span class="spinner spinner-white" v-if="loading"></span>
              <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Save
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button
              class="box-shadow2"
              size="sm"
              :variant="isDarkMode ? 'outline-warning' : 'warning'"
              :to="{ path: `${listUrl}` }"
            >
              <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import { numeric, maxLength, required, minLength } from 'vuelidate/lib/validators';
import { mapGetters, mapState, mapActions } from 'vuex';
import User from '@/model/user';
import router from '@/router';
import { ModelSelect } from 'vue-search-select';
import Multiselect from 'vue-multiselect';

export default {
  name: 'KycFormBox',
  components: {
    ModelSelect,
    Multiselect
  },
  props: {
    listUrl: String,
    userType: String,
    formType: String,
    userId: {
      type: Number,
      required: false
    }
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  data() {
    return {
      title: '',
      options: [],
      storeid: {
        value: '',
        text: ''
      },
      pinCodeOptions: [],
      formLoaded: false,
      form: {
        mobile: null,
        name: null,
        address: null,
        gender: 'Male',
        age: '',
        store: '',
        communicationMode: 'WHATSAPP',
        pinCode: '',
        department: '',
        createdBy: ''
      },
      storeIdError: null
    };
  },
  validations() {
    const formValidation = {
      mobile: {
        required,
        numeric,
        maxLength: maxLength(10),
        minLength: minLength(10)
      },
      name: {
        required
      },
      address: {
        required
      },
      createdBy: {
        required
      },
      department: {
        required
      }
    };

    return { form: formValidation };
  },
  mounted() {
    this.listStore({ router });
    this.$nextTick(async () => {
      // Code that will run only after the entire view has been re-rendered
      if (this.formType === 'new') {
        if (this.userType === 'staff') {
          this.form.role = User.userRole.staff;
        }
        this.form.status = User.userEnabled.active;
        this.formLoaded = true;
        this.$v.$touch(); // Set initial validation
        this.$v.$reset(); // Reset $dirty
      }
    });
  },
  computed: {
    ...mapState('kyc', ['loading', 'pincodes']),
    metaDescription() {
      return this.formType === 'new' ? 'Add new user' : 'Update user';
    },
    ...mapGetters('alert', ['errorMessages']),
    ...mapState('user', ['loading', 'user']),
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('store', ['storeList']),
    ...mapState('auth', {
      authUser: 'user'
    })
  },
  methods: {
    ...mapActions('store', ['listStore']),
    limit(e) {
      return e.slice(0, 10);
    },
    onSubmit() {
      this.storeIdError = null;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      const kyc = {
        mobile: parseInt(this.form.mobile, 10),
        customerName: this.form.name,
        favouriteStore: this.form.store,
        address: this.form.address,
        gender: this.form.gender,
        age: this.form.age,
        pinCode: this.form.pinCode,
        communicationMode: this.form.communicationMode,
        createdBy: this.form.createdBy,
        department: this.form.department
      };
      this.$emit('add', { kyc });
      return false;
    }
  },
  watch: {
    pincodes(newValue) {
      if (newValue.length) {
        this.pinCodeOptions = newValue;
      }
    },
    storeList(_newValue) {
      let comparingStores = [];
      comparingStores = _newValue.map(store => ({
        storeid: store.storeid
      }));
      this.newStoreList = comparingStores;
      this.options = _newValue.map(store => store.storeid);
    }
  }
};
</script>
<style src="vue-search-select/dist/VueSearchSelect.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
